import { LINES } from "@/lib/games";

const COLORS = ["#FFD700", "#ff2d55", "#38bdf8", "#a3e635", "#f0abfc"];

export const WinLines = ({ wins }) => (
  <svg viewBox="0 0 500 300" preserveAspectRatio="none" className="absolute inset-2 w-[calc(100%-1rem)] h-[calc(100%-1rem)] pointer-events-none z-10" data-testid="win-lines">
    {wins.map((w) => (
      <polyline key={w.line} fill="none" stroke={COLORS[w.line]} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"
        points={LINES[w.line].map((row, r) => `${r * 100 + 50},${row * 100 + 50}`).join(" ")}
        style={{ filter: `drop-shadow(0 0 6px ${COLORS[w.line]})` }} className="animate-pulse" />
    ))}
  </svg>
);
